import React from "react";

export const PrivacyPolicy = () => {
  return (
    <div style={{ padding: "20px" }}>
      <h1>Privacy Policy</h1>
      <p>
        <strong>Effective Date:</strong> [10/09/2024]
      </p>

      <h2>1. Introduction</h2>
      <p>
        Welcome to Nova Clothing Brand. We value your privacy and are committed
        to protecting your personal information. This Privacy Policy explains
        how we collect, use, and safeguard your data when you visit our website
        or make a purchase.
      </p>

      <h2>2. Information We Collect</h2>
      <p>
        <strong>Personal Information:</strong> When you make a purchase or
        create an account, we collect personal information such as your name,
        email address, shipping address, phone number, and payment details.
      </p>
      <p>
        <strong>Browsing Information:</strong> We collect information about your
        interactions with our website, including IP address, browser type, and
        the pages you visit.
      </p>

      <h2>3. How We Use Your Information</h2>
      <p>
        <strong>Order Processing:</strong> We use your personal information to
        process and fulfill your orders, provide customer service, and send you
        order updates.
      </p>
      <p>
        <strong>Marketing:</strong> With your consent, we may send you
        promotional emails about new products, special offers, or other
        information we think you may find interesting.
      </p>
      <p>
        <strong>Improvement of Services:</strong> We use browsing information to
        improve our website, customize your experience, and better understand
        our customers' preferences.
      </p>

      <h2>4. Sharing Your Information</h2>
      <p>
        <strong>Service Providers:</strong> We may share your information with
        third-party service providers who assist us with payment processing,
        shipping, and marketing. These providers are contractually obligated to
        protect your information.
      </p>
      <p>
        <strong>Legal Requirements:</strong> We may disclose your information if
        required by law or in response to legal requests, such as subpoenas or
        court orders.
      </p>

      <h2>5. Cookies</h2>
      <p>
        Our website uses cookies to enhance your browsing experience. Cookies
        are small files stored on your device that help us analyze web traffic
        and remember your preferences. You can choose to accept or decline
        cookies through your browser settings.
      </p>

      <h2>6. Data Security</h2>
      <p>
        We take data security seriously and implement appropriate technical and
        organizational measures to protect your personal information from
        unauthorized access, disclosure, or misuse.
      </p>

      <h2>7. Your Rights</h2>
      <p>
        You have the right to access, correct, or delete your personal
        information. If you wish to exercise these rights, please contact us at
        [Insert Contact Information].
      </p>

      <h2>8. Changes to This Privacy Policy</h2>
      <p>
        We may update this Privacy Policy from time to time. Any changes will be
        posted on this page with an updated effective date.
      </p>

      <h2>9. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, please
        contact us at:
      </p>
      <p>
        <strong>Nova Clothing Brand</strong>
        <br />
        [Nagpur]
        <br />
        Email: [ac240605@gmail.com]
        <br />
      </p>
    </div>
  );
};
